import { subscribeToStomp } from "@/services/stomp-service";
import { IAuthData } from "@/model/IAuthData";
import { Subject } from "rxjs";
import { NotificationDto } from 'water-rest/src/model/messaging/NotificationDto';

export const onMessageReceive: Subject<NotificationDto> = new Subject<NotificationDto>();

const showNotify = (data: NotificationDto | any) => {
    onMessageReceive.next(data);
}

export const subscribeToNotification = (authData: IAuthData) => {
    subscribeToStomp({
        subscriptionName: 'messages',
        topicName: `/topic/messages/${authData.sub}`,
        callback: showNotify
    });
    subscribeToStomp({
        subscriptionName: 'messages_global',
        topicName: `/topic/messages`,
        callback: showNotify
    });
}
